import { render, staticRenderFns } from "./Datamatrix.vue?vue&type=template&id=5b279b73"
import script from "./Datamatrix.vue?vue&type=script&lang=js"
export * from "./Datamatrix.vue?vue&type=script&lang=js"
import style0 from "./Datamatrix.vue?vue&type=style&index=0&id=5b279b73&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports